export default __webpack_public_path__ + "static/media/Montserrat-BoldItalic.bf331673.woff";